/**
 * reCAPTCHA config: only enable on production domain (socialbnb.org)
 * to avoid adding every staging/test URL to Google reCAPTCHA console.
 */
const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LftDz4sAAAAAN-4dfwRzdiigM-FssRtjJ5vpv4R';

const RECAPTCHA_ALLOWED_DOMAIN = 'socialbnb.org';

const isRecaptchaEnabled = () => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname || '';
  return hostname === RECAPTCHA_ALLOWED_DOMAIN || hostname.endsWith(`.${RECAPTCHA_ALLOWED_DOMAIN}`);
};

export { RECAPTCHA_SITE_KEY, isRecaptchaEnabled };
